import { render, staticRenderFns } from "./ImgHeader.vue?vue&type=template&id=48b52c21&scoped=true"
import script from "./ImgHeader.vue?vue&type=script&lang=js"
export * from "./ImgHeader.vue?vue&type=script&lang=js"
import style0 from "./ImgHeader.vue?vue&type=style&index=0&id=48b52c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b52c21",
  null
  
)

export default component.exports